<div class="tariff-list" *ngIf="tariffs" data-qa-block="tariff-list">
  <div class="tariff" *ngFor="let tariff of tariffs; trackBy: trackById" data-qa="tariff">
    <div class="tariff-name" data-qa="tariff-name">{{ tariff.name }}</div>

    <div class="center-column">
      <div class="tariff-price__year">
        <span class="price-amount" data-qa="tariff-year-price">{{
          tariff | tariffPrice: 'YEAR' | kzCurrency
        }}</span>
        <span data-qa="tariff-year-period">{{ 'tariffs.period.for.one.year' | translate }}</span>
      </div>
      <ng-container *ngIf="tariff.benefit" data-qa="tariff-benefit">
        {{ 'tariffs.benefit' | translate }} – {{ tariff.benefit | kzCurrency }}
      </ng-container>
    </div>

    <div class="right-column">
      <div class="tariff-price">
        <span class="price-amount" data-qa="tariff-month-price">{{
          tariff | tariffPrice | kzCurrency
        }}</span>
        <span class="price-period" translate data-qa="tariff-month-period"
          >tariffs.period.MONTH</span
        >
      </div>
      <div class="tariff-options" *ngIf="!activeTariff">
        <button
          *ngIf="tariff.name !== selectedTariff?.name"
          class="button_blue"
          (click)="selectTariff(tariff)"
          translate
          data-qa-button="select-tariff"
        >
          button.select
        </button>
        <div *ngIf="tariff.name === selectedTariff?.name" class="selected-tariff-mark">
          <tax-icon name="done" class="icon"></tax-icon>
          <span data-qa="tariff-selected-text">{{ 'tariff.selected.state' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
